import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import SelectedSeriesElement from '../../SelectedSeriesElement';
import { Link } from 'react-router-dom';
import StatusIcon from '../../../StatusIcon';

const SeriesNavElement = ({
  series,
  selectedModelId,
  isSelectedSeries,
  modelUrl,
  hasQuota,
  seriesId,
  nameStyle,
}) => (
  <div>
    {isSelectedSeries ? (
      <SelectedSeriesElement
        series={series}
        selectedModelId={selectedModelId}
        seriesId={seriesId}
      />
    ) : (
      <Link to={modelUrl}>
        <div
          className={
            hasQuota ? styles.seriesNavElement : styles.disabledElement
          }
          style={nameStyle}
        >
          {series.name}
          <StatusIcon
            totalQuota={series.totalQuota}
            submitted={series.submitted}
            sideNav
          />
        </div>
      </Link>
    )}
  </div>
);

export default enhance(SeriesNavElement);
